import React, { Component } from "react";
import { injectIntl } from "@ai360/core/intl";
import { actions, service } from "./data";
import { withCrud, withMasked, withNewApiResult, withValidateImportResults } from "~/hocs";
import { IAgBytesProps, IAgBytesState } from "../interfaces";
// Components
import { ImportExportHeader } from "../components/import-export-header";
import { DataTable } from "~/core";
import { messages } from "../i18n-messages";

export class SampleAttribute_ extends Component<
    IAgBytesProps<typeof actions, void>,
    IAgBytesState
> {
    constructor(props: IAgBytesProps<typeof actions, void>) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
    }

    public onToggleModalClick = (): void => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    render(): JSX.Element {
        return (
            <div className="content-table-container">
                <ImportExportHeader
                    onlyImportExportOptions
                    hideActiveRecordLink
                    {...this.props}
                    service={service}
                    onToggleModalClick={this.onToggleModalClick}
                    onToggleActiveClick={service.toggleColumnVisibility}
                />
                <DataTable service={service} messages={messages} {...this.props} isCheckbox />
            </div>
        );
    }
}
export const SampleAttribute = injectIntl(
    withMasked(
        withNewApiResult(
            withValidateImportResults(
                withCrud(SampleAttribute_, service, actions),
                actions.importData
            )
        )
    )
);
